import { getNestedProperty } from '@opallabs/lambda'

function findFirstPhaseWhere(phases, finder) {
  for (let i = 0; i < phases.length; i += 1) {
    const phase = phases[i]
    if (finder(phase)) {
      return phase
    }
  }
  return null
}

export function findFirstNonCompletePhase(phases = []) {
  const finder = (phase) => getNestedProperty(phase, 'status') !== 'complete'
  return findFirstPhaseWhere(phases, finder)
}

export function findFirstCompletePhase(phases = []) {
  const finder = (phase) => getNestedProperty(phase, 'status') === 'complete'
  return findFirstPhaseWhere(phases, finder)
}

export function findFirstPhaseAfterCurrent(phases = []) {
  for (let i = 0; i < phases.length; i += 1) {
    const phase = phases[i]
    if (phase && phase.is_current) {
      return phases[i + 1]
    }
  }
  return null
}

export default {
  findFirstCompletePhase,
  findFirstNonCompletePhase,
  findFirstPhaseAfterCurrent,
}
